module.exports = __webpack_public_path__ + "images/stars.3f9b4fea19413cdbaf75.svg";